import styled, { RuleSet, css } from 'styled-components';

const Title = styled.div<{
  $desktopStyles?: RuleSet<object>;
  $mobileStyles?: RuleSet<object>;
}>(
  ({ theme, $desktopStyles, $mobileStyles }) => css`
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-size: 32px;
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: 125%;
    /* or 40px */
    ${$mobileStyles}

    @media (min-width: ${theme.sz.md}) {
      ${$desktopStyles}
    }
  `,
);

export default Title;
